<template>
  <nav data-testid="breadcrumbs">
    <ol class="list-reset mb-8 flex">
      <li v-for="(item, index) in items" :key="item.text">
        <RouterLink
          v-if="item.to"
          :to="item.to"
          class="mx-1 text-subtlest visited:text-subtlest hover:text-main hover:underline"
          data-testid="breadcrumb-link"
        >
          {{ item.text }}
        </RouterLink>
        <span v-else class="mx-1">
          {{ item.text }}
        </span>
        <MdiSvg v-if="index !== items.length - 1" class="mx-1 inline-block text-subtlest" :path="mdiChevronRight" :size="14" />
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
import { mdiChevronRight } from '@mdi/js'
import { MdiSvg } from '@ramp106/omrjs-core-ui'
import { type RouteLocationRaw } from 'vue-router'

export type BreadcrumbItem = {
  text: string
  to?: RouteLocationRaw
}

defineProps<{
  items: BreadcrumbItem[]
}>()
</script>
